// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"removeButton__yNvZX","addButtonWrap":"addButtonWrap__Tbq-L"};